import { put, call, takeLatest, all } from "redux-saga/effects";
import { requestCreator, successCreator, failureCreator } from "../utils/action";
import { Types } from "../actions/admin-dashboard";
import API from "../api/admin-dashboard";

function* sagaAction(action) {
  const type = action.type;
  try {
    yield put(requestCreator(type, {}));
    const payload = yield call(API[type], action);
    yield put(successCreator(type, payload));
  }
  catch (err) {
    console.error(err);
    yield put(failureCreator(type, { err }));
  }
}

export function* adminDashboardSaga() {
  yield all([
    takeLatest(Types.SEARCH_INVESTMENTS,        sagaAction),
    takeLatest(Types.SEARCH_WALLETS,            sagaAction),
    takeLatest(Types.SEARCH_COMPENSATIONS,      sagaAction),
    takeLatest(Types.GET_EVENTS,                sagaAction),
    takeLatest(Types.GET_INVESTMENT_INTENTIONS, sagaAction),
  ]);
}
